import React from 'react';
import { useKey } from './useKey';

export interface IKeyboardShortcutProps {
  triggerKey: string;
  onAction: () => void;
}

export const KeyboardShortcut: React.FC<IKeyboardShortcutProps> = ({ onAction, triggerKey }) => {
  useKey(triggerKey, onAction);
  return <></>;
};
